import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import { EventBus } from "../../../event-bus";
import * as consts from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";

export const state = {
  columnMappings: [],
  columnMapping: {},
  pagination: {
    count: 20,
    total: 0
  },
  defaultColumnMappings: [],
  eligibilityColumnMappings: [],
  incentiveColumnMappings: []
};

export const getters = {
  [consts.GETTER_LIST_COLUMN_MAPPING]: state => state.columnMappings,
  [consts.GETTER_COLUMN_MAPPING]: state => state.columnMapping,
  [consts.GETTER_DEFAULT_COLUMN_MAPPING_FIELDS]: state => state.defaultColumnMappings
};

export const actions = {
  [consts.ACTION_GET_LIST_COLUMN_MAPPING]: ({ commit }, options) => {
    makeCall(
      getEndPoints().columnMapping.getColumnMappings,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response.data) {
        commit(consts.MUTATION_SET_LIST_COLUMN_MAPPING, response);
      }
    });
  },
  [consts.ACTION_GET_COLUMN_MAPPING]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().columnMapping.getById.replace(
          ':id',
          options.id
        ),
        buildOptions('GET', options),
        commit
      )
        .then(response => {
          resolve(response);
        })
        .catch(function({ response }) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            (response.data && response.data.message) || "Something went wrong"
          );
          reject(response);
        });
    });
  },
  [consts.ACTION_SET_COLUMN_MAPPING]: ({ commit }, options) => {
    let method = options.isEditing ? 'PUT' : 'POST';
    let url = options.isEditing
      ? getEndPoints().columnMapping.setColumnMapping.replace(
        ':id',
        options.id
      )
      : getEndPoints().columnMapping.addColumnMapping;
    makeCall(url, buildOptions(method, options.data), commit)
      .then(response => {
        if (response.error) {
          if (options.errorHandling) {
            options.errorHandling(response.error);
          }
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || 'Something went wrong'
        );
      });
  },
  [consts.ACTION_GET_DEFAULT_COLUMN_MAPPING_FIELDS]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().columnMapping.getDefaultFieldsByDataType,
        buildOptions('GET', options),
        commit
      )
        .then(response => {
          if (response.data) {
            commit(consts.MUTATION_SET_LIST_DEFAULT_COLUMN_MAPPING_FIELDS, response);
          }
        })
        .catch(function({ response }) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            (response.data && response.data.message) || "Something went wrong"
          );
          reject(response);
        });
    });
  },
}

export const mutations = {
  [consts.MUTATION_SET_LIST_COLUMN_MAPPING]: (state, columnMappings) => {
    state.columnMappings = columnMappings;
  },
  [consts.MUTATION_SET_COLUMN_MAPPING]: (state, columnMapping) => {
    state.columnMapping = columnMapping;
  },
  [consts.MUTATION_SET_LIST_DEFAULT_COLUMN_MAPPING_FIELDS]: (state, data) => {
    state.defaultColumnMappings = data;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/column_mapping/index.js